import React, { useState, useEffect } from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicSwitches from "../../components/BasicSwitches";
import EditIcon from "@mui/icons-material/Edit";
import SavingsIcon from "@mui/icons-material/Savings";
import loader from "../../assets/loader.webp";
import Pagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import { fetchData, deleteData, getDataById } from "../../utility/adminApi";
import AddLoyaltyPoint from "./AddLoyaltyPoint";
import EditLoyaltyPoint from "./EditLoyaltyPoint";
import { adminAxios } from "../../axiosInstance";
import { formatNumbersWithDecimal } from "../../components/formatNumbersWIthDecimal";

function LoyaltyPoint() {
  const [loyaltyData, setLoyaltyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [addtab, setAddtab] = useState(false);
  const [edittab, setEdittab] = useState(false);
  const [viewTab, setViewTab] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [singleData, setSingleData] = useState({});
  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [searchData, setSearchData] = useState("");

  const handleChange = async (e) => {
    setSearchData(e.target.value);
  };

  const fetchLoyalty = async (page = 1, search = "") => {
    const response = await fetchData(
      "loyalty-settings",
      currentPage,
      searchData
    );
    setLoyaltyData(response?.data?.data || []);

    setTotalPage(response?.data?.last_page);
    setIsLoading(false);
    setIsNextLoading(false);
    setIsPrevLoading(false);
  };

  // Fetch data on page change or search query change
  useEffect(() => {
    fetchLoyalty(currentPage, searchData);
  }, [currentPage, searchData]);

  const handleCurrentPage = (page) => {
    setCurrentPage(page);
  };

  const handleAdd = () => {
    setAddtab(true);
    setEdittab(false);
  };

  const handleSingleFile = async (id, setEditTab = false) => {
    const response = await getDataById("loyalty-settings/show/", id);
    setSingleData(response?.data?.data);
    if (setEditTab) {
      setEdittab(true);
    } else {
      setViewTab(true);
    }
  };

  const handleDelete = (id) => {
    setCompanyIdToDelete(id);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    const response = await deleteData(
      "loyalty-settings/delete/",
      companyIdToDelete
    );
    fetchLoyalty(currentPage); //
    setIsModalOpen(false);
  };

  return (
    <div className="lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between  items-center p-4 w-full">
        <h3 className="text-xl font-semibold">
          <SavingsIcon /> Loyalty Point
        </h3>
        <div className="flex gap-6">
          <button
            onClick={handleAdd}
            className="p-3 rounded-lg text-white bg-blue-500"
          >
            Add Point <AddIcon />
          </button>{" "}
        </div>{" "}
      </div>

      {addtab && !edittab && !viewTab && (
        <AddLoyaltyPoint
          setIsLoading={setIsLoading}
          setAddtab={setAddtab}
          fetchLoyalty={fetchLoyalty}
          currentPage={currentPage}
        />
      )}
      {edittab && !addtab && !viewTab && (
        <EditLoyaltyPoint
          singleData={singleData}
          setSingleData={setSingleData}
          setEdittab={setEdittab}
          setLoading={setIsLoading}
          currentPage={currentPage}
          fetchCategories={fetchLoyalty}
        />
      )}

      {!edittab && !addtab && !viewTab && (
        <div className="w-full p-4  flex flex-col gap-2 bg-white">
          <div className="flex gap-2">
            {/* Consider resarching for MUI UI search bar  */}
            <input
              placeholder="Search for"
              type="text"
              name="cat_name"
              // id="email"
              value={searchData}
              onChange={handleChange}
              className="border-2 border-gray-400 w-60 p-2 px-6"
            />
          </div>
          <div className="w-full">
            {isLoading ? (
              <div className="  flex justify-center items-center">
                {" "}
                <img
                  src={loader}
                  alt="loader"
                  className=" w-10 lg:w-20 "
                />{" "}
              </div>
            ) : (
              <table className="min-w-full bg-white border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="py-2 px-4 border-b border-gray-300">NAME</th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      POINT
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      MINIMUM PRICE
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      STATUS
                    </th>
                    <th className="py-2 px-4 border-b border-gray-300">
                      ACTIONS
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {loyaltyData.map((item) => (
                    <tr
                      key={item?.id}
                      className="hover:bg-gray-100 border-b border-gray-300"
                    >
                      <td className="py-2 px-4 text-wrap">{item?.name}</td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {item?.point}
                      </td>
                      <td className="py-2 px-4 text-center text-wrap">
                        {formatNumbersWithDecimal(item?.minimum_price)}
                      </td>
                      <td
                        className={`py-2 text-white  px-4 text-center text-wrap`}
                      >
                        <div
                          className={`p-1 rounded-md ${
                            item?.is_active == 1 ? "bg-green-500" : "bg-red-500"
                          }`}
                        >
                          {item?.is_active == 1 ? "Active" : "Inactive"}
                        </div>
                      </td>
                      <td className="py-2 px-4 flex gap-2 justify-center items-center">
                        <EditIcon
                          onClick={() => handleSingleFile(item?.id, true)}
                          className="text-blue-600 cursor-pointer"
                        />
                        <DeleteIcon
                          onClick={() => handleDelete(item?.id)}
                          className="text-red-600 cursor-pointer"
                        />
                        <BasicSwitches
                          status={item?.is_active}
                          id={item?.id}
                          api="loyalty-settings"
                          requestType="put"
                          instanceType={adminAxios}
                          fetchLoyalty={fetchLoyalty}
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <Pagination
              onPageChange={handleCurrentPage}
              totalPage={totalPage}
              currentPage={currentPage}
              setIsNextLoading={setIsNextLoading}
              setIsPrevLoading={setIsPrevLoading}
              isPrevLoading={isPrevLoading}
              isNextLoading={isNextLoading}
            />
          </div>

          {/* For Pagination */}
          {/* <Pagination
            onPageChange={handleCurrentPage}
            totalPage={totalPage}
            currentPage={currentPage}
            pageLoading={pageLoading}
          /> */}
        </div>
      )}
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Delete"
        text2="Are you sure you want to delete the point?"
      />
    </div>
  );
}

export default LoyaltyPoint;
